import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AsyncSelect from 'react-select/async';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import * as addressStore from "../../../redux/store/address/address.store";
import history from "../../../common/history";
import { useForm } from "react-hook-form";
var query = null;

export default function SearchView(props) {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const [isOpen, setIsOpen] = useState(false);

    const { register, handleSubmit, formState: { errors } } = useForm();
    useEffect(() => {
        const fromMap = queryParams.get("fromMap") === 'true';
        if (fromMap) {
            queryParams.delete("fromMap");
            history.push({ search: queryParams.toString() });
        }
    }, []);

    useEffect(() => {
        const id = queryParams.get("id");
        const code = queryParams.get("code");
        const fromMap = queryParams.get("fromMap") === 'true';
        if(!props.isDoneConstructMap) return;
        if (code) {
            GetAddressByCode(code, fromMap);
        }
        else if (id) {
            getAddressById(id);
        } else {
            props.setDcsData(null);
            handleZoom([105.345075, 21.296315], 17, false);
        }
    }, [props.isDoneConstructMap, location.search]);

    const GetAddressByCode = async (code, hasAnimation) => {
        const res = await addressStore.GetAddressByCode(code);
        if (res.content) {
            const paths = res.content?.images?.map(item => item.path);

            // Chuyển thành string giống yêu cầu
            const result = JSON.stringify(paths);
            let data = {
                ...res.content,
                imagePathsRaw: result,
                value: res.content.id,
                label: res.content.houseOwner + ', ' + (res.content.houseNumber ? res.content.houseNumber + ', ' : '') + res.content.streetName + ', ' + res.content.communeName + ', ' + res.content.provinceName,
            }
            props.setDcsData(data);
            !hasAnimation && handlePinMarkerMode(data.longitude, data.latitude);
        }
    }
    
    const getAddressById = async (id) => {
        const res = await addressStore.GetAddressById(id);
        if (res.content) {
            const paths = res.content?.images?.map(item => item.path);

            // Chuyển thành string giống yêu cầu
            const result = JSON.stringify(paths);
            let data = {
                ...res.content,
                imagePathsRaw: result,
                value: res.content.id,
                label: res.content.houseOwner + ', ' + (res.content.houseNumber ? res.content.houseNumber + ', ' : '') + res.content.streetName + ', ' + res.content.communeName + ', ' + res.content.provinceName,
            }
            props.setDcsData(data);
            handlePinMarkerMode(data.longitude, data.latitude);
        }
    };

    const onSubmit = (data) => {
        console.log(data);
    }

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            border: '1px solid #e2e8f0',
            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
            borderRadius: '0.5rem',
            zIndex: 10,
            // top: '38px',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? '#f1f5f9' : 'white',
            color: '#0f172a',
            cursor: 'pointer',
            '&:active': {
                backgroundColor: '#e2e8f0',
            },
        }),
        control: (provided) => ({
            ...provided,
            minHeight: '42px',
            border: '1px solid #cbd5e1',
            boxShadow: '0 0 1px #1883db',
            borderRadius: '2rem',
            padding: '4px 4px 4px 8px',
            '&:hover': {
                borderColor: '#1883db',
            },
            '&:focus': {
                borderColor: '#1883db',
            },
        }),
        valueContainer: (provided) => ({
            ...provided,
            cursor: 'text',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            cursor: 'pointer',
        }),
    };

    const loadOptions = (inputValue, callback) => {
        if (query) {
            clearTimeout(query);
        }
        let params = {
            pageIndex: 1,
            pageSize: 100,
        }
        if (inputValue.length > 2) {
            query = setTimeout(() => {
                if (inputValue) {
                    const getListAddress = async () => {
                        let results = [];
                        const res = await addressStore.GetAddressList({ ...params, streetName: inputValue });
                        if (res.content && res.content.length > 0) {
                            results = res.content.map(item => {
                                return {
                                    ...item,
                                    value: item.id,
                                    label: item.houseOwner + ', ' + (item.houseNumber ? item.houseNumber + ', ' : '') + item.streetName + ', ' + item.communeName + ', ' + item.provinceName,
                                };
                            })
                        }
                        callback(results);
                    };
                    getListAddress();
                }
            }, 800);
        } else {
            callback([]);
        }
    };

    const handleChoose = (data) => {
        console.log('data', data);
        props.setDcsData(data);
        const searchParams = new URLSearchParams();
        if (data.code) {
            searchParams.set('code', data.code);
            searchParams.delete('id');
        } else {
            searchParams.set('id', data.id);
            searchParams.delete('code');
        }
        history.push({
            search: `?${searchParams.toString()}`
        });
        handlePinMarkerMode(data.longitude, data.latitude);
    }

    const handlePinMarkerMode = (longitude, latitude, zoom = 18) => {
        if(!props.openLayerController) return;
        props.openLayerController.placeSearch([
            longitude,
            latitude
        ], null, false, true, zoom);
    }

    const handleZoom = (center, zoom, animate) => {
        if(!props.openLayerController) return;
        props.openLayerController.handleZoom(center, zoom, animate);
    }
    return (
        <div className="search-dcs">
            <div className="search-dcs-input">
                <AsyncSelect
                    isDisabled={isOpen}
                    defaultOptions={[]}
                    className='search_input_dcs w-100'
                    placeholder='Nhập để tìm kiếm'
                    isLoading={false}
                    loadOptions={loadOptions}
                    onChange={data => {
                        handleChoose(data);
                    }}
                    noOptionsMessage={() => "Không tìm thấy kết quả"}
                    value={props.dcsData}
                    components={{ DropdownIndicator: null, LoadingIndicator: null, ClearIndicator: null }}
                    styles={customStyles}
                />
                {/* <button onClick={() => setIsOpen(!isOpen)} className="btn btn-primary">
                    <FontAwesomeIcon icon={faChevronDown} />
                </button> */}
            </div>
            <form onSubmit={handleSubmit(onSubmit)} hidden={!isOpen}>
                <div className="form-group form-dcs">
                    <div className="row">
                        <div className="col-lg-6">
                            <label>
                                Số nhà
                            </label>
                            <div className="text-left">
                                <input
                                    ref={register({
                                        required: true,
                                    })}
                                    type="text"
                                    name="houseNumber"
                                    className="form-control input-info"
                                    placeholder="Số nhà"
                                />
                                {errors.houseNumber && errors.houseNumber.type === "required" && (
                                    <span className="error">Trường này là bắt buộc</span>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <label>
                                Số nhà
                            </label>
                            <div className="text-left">
                                <input
                                    ref={register({
                                        required: true,
                                    })}
                                    type="text"
                                    name="houseNumber"
                                    className="form-control input-info"
                                    placeholder="Số nhà"
                                />
                                {errors.houseNumber && errors.houseNumber.type === "required" && (
                                    <span className="error">Trường này là bắt buộc</span>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <label>
                                Số nhà
                            </label>
                            <div className="text-left">
                                <input
                                    ref={register({
                                        required: true,
                                    })}
                                    type="text"
                                    name="houseNumber"
                                    className="form-control input-info"
                                    placeholder="Số nhà"
                                />
                                {errors.houseNumber && errors.houseNumber.type === "required" && (
                                    <span className="error">Trường này là bắt buộc</span>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <label>
                                Số nhà
                            </label>
                            <div className="text-left">
                                <input
                                    ref={register({
                                        required: true,
                                    })}
                                    type="text"
                                    name="houseNumber"
                                    className="form-control input-info"
                                    placeholder="Số nhà"
                                />
                                {errors.houseNumber && errors.houseNumber.type === "required" && (
                                    <span className="error">Trường này là bắt buộc</span>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <label>
                                Số nhà
                            </label>
                            <div className="text-left">
                                <input
                                    ref={register({
                                        required: true,
                                    })}
                                    type="text"
                                    name="houseNumber"
                                    className="form-control input-info"
                                    placeholder="Số nhà"
                                />
                                {errors.houseNumber && errors.houseNumber.type === "required" && (
                                    <span className="error">Trường này là bắt buộc</span>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <button type="submit" className="btn btn-primary">Tìm kiếm</button>
                        </div>
                    </div>
                </div>
            </form>
        </div >
    );
}